<div class="bg-th-blue mt-0 container-fluid py-2">
  <div class="d-flex justify-content-between align-content-center">
    <i
      class="fa fa-arrow-left text-secondary my-auto pointer text-white"
      routerLink="/"
    ></i>
    <a class="d-flex align-items-center text-secondary f18 my-auto text-white">
      <span> لیست دیزل‌ها </span>
    </a>
  </div>
</div>

<main class="px-2">
  <div class="container-fluid row gx-2 gy-2 mt-3 p-2">
    <!-- جستجو -->
    <div class="col-12 col-md-8">
      <input
        class="w-100 form-control"
        (input)="filterList($event.target)"
        placeholder="جستجو کنید ..."
      />
    </div>

    <!-- افزودن -->
    <div class="col-12 col-md-auto d-flex align-items-center">
      <button class="btn btn-primary w-100" (click)="openModal()">
        افزودن
      </button>
    </div>

    <!-- خروجی اکسل -->
    <div class="col-12 col-md-auto d-flex align-items-center">
      <button class="btn btn-success w-100">خروجی اکسل</button>
    </div>

    <!-- نقشه -->
    <div class="col-12 col-md-auto d-flex align-items-center">
      <button class="btn btn-secondary w-100" (click)="showAllInMap()">نقشه</button>
    </div>

    <!-- جدول اطلاعات -->
    <div class="section border mt-4">
      <table class="col-12 table table-striped rounded-3" id="Export_Excel">
        <thead>
          <tr class="text-center">
            <th scope="col">#</th>
            <th scope="col">عملیات</th>
            <th scope="col">تاریخ ثبت</th>
            <th scope="col">تاریخ اعتبار</th>
            <th scope="col">نام</th>
            <th scope="col">ساعت کارکرد</th>
            <th scope="col">سوخت مصرفی (لیتر)</th>
            <th scope="col">مدل</th>
            <th scope="col">برند</th>
            <th scope="col">توان (کیلووات)</th>
          </tr>
        </thead>

        <tbody>
          <tr class="f14 text-center" *ngFor="let item of loadwatches; let i = index">
            <th scope="row" class="text-dark">{{ i + 1 | faNum }}</th>
            <td>

              <!-- ویرایش -->
              <a class="btn btn-sm btn-link p-0 me-1" title="ویرایش" (click)="openModal(item)">
                <i class="fa fa-pencil fa-lg text-dark"></i>
              </a>
              <!-- حذف -->
              <a class="btn btn-sm btn-link p-0 me-1" title="حذف" (click)="removeItem(item,i)">
                <i class="fa fa-trash fa-lg text-dark"></i>
              </a>
              <!-- داشبورد -->
              <a
                class="btn btn-sm btn-link p-0 me-1"
                target="_blank"
                title="داشبورد"
                [routerLink]="['../', item.strIMEI]"
              >
                <i class="fa fa-bar-chart fa-lg text-dark"></i>
              </a>
              <!-- موقعیت -->
              <a class="btn btn-sm btn-link p-0 me-1" title="موقعیت" (click)="showInMap(item)">
                <i class="fa fa-map fa-lg-alt text-dark"></i>
              </a>
            </td>
            <td>{{ item.strRegisterDate }}</td>
            <td>{{ item.strExpireDate }}</td>
            <td>{{ item.strName }}</td>
            <td>{{ item.fOperatingHours }}</td>
            <td>{{ item.fFuelConsumptionTotal }}</td>
            <td>{{ item.strModel }}</td>
            <td>{{ item.strBrand }}</td>
            <td>{{ item.fRatedPowerKW | faNum }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</main>

<div class="modal fade" id="addLoadWatch" tabindex="-1">
  <div class="modal-dialog modal-lg">
    <div class="modal-content dirI">
      <div class="modal-header dirI">
        <h5 class="modal-title" id="exampleModalLabel">
          اطلاعات دیزل را وارد کنید
        </h5>
        <button class="btn-close" data-bs-dismiss="modal"></button>
      </div>
      <div [formGroup]="addOrEditForm" class="modal-body">
        <div class="container-fluid row gx-2 g-3 p-2">
          
          <!-- بررسی شناسه -->
          <ng-container *ngIf="!addOrEditForm.get('iLoadWatch')?.value">

            <!-- شناسه دیزل-->
            <div class="position-relative col-12 col-md-4">
              <label class="mb-2 text-muted"> شناسه دیزل</label>
              <input class="form-control p-2 text-center" formControlName="strIMEI" appNumericOnly inputmode="numeric" maxlength="17" />
            </div>

            <!-- بررسی -->
            <div class="position-relative col-12 col-md-8">
              <button class="btn btn-primary" (click)="verifyIMEI()"> بررسی شناسه</button>
            </div>

          </ng-container>

          <!-- نام-->
          <div class="position-relative col-12 col-md-4">
            <label class="mb-2 text-muted"> نام</label>
            <input class="form-control p-2 text-center" formControlName="strName" />
          </div>
          
          <!-- شماره سریال-->
          <div class="position-relative col-12 col-md-4">
            <label class="mb-2 text-muted"> شماره سریال</label>
            <input class="form-control p-2 text-center" formControlName="strSerialNumber" />
          </div>
          
          <!-- مدل-->
          <div class="position-relative col-12 col-md-4">
            <label class="mb-2 text-muted"> مدل </label>
            <input class="form-control p-2 text-center" formControlName="strModel" />
          </div>

          <!-- برند-->
          <div class="position-relative col-12 col-md-4">
            <label class="mb-2 text-muted"> برند </label>
            <input class="form-control p-2 text-center" formControlName="strBrand" />
          </div>

          <!-- تعداد قطب-->
          <div class="position-relative col-12 col-md-4">
            <label class="mb-2 text-muted"> تعداد قطب </label>
            <input class="form-control p-2 text-center" formControlName="tiPoleCount" appNumericOnly inputmode="numeric" />
          </div>

          <!-- توان نامی-->
          <div class="position-relative col-12 col-md-4">
            <label class="mb-2 text-muted"> توان نامی </label>
            <input class="form-control p-2 text-center" formControlName="fRatedPowerKW" appNumericOnly inputmode="numeric" />
          </div>

          <!-- ولتاژ نامی-->
          <div class="position-relative col-12 col-md-4">
            <label class="mb-2 text-muted"> ولتاژ نامی </label>
            <input class="form-control p-2 text-center" formControlName="iRatedVoltage" appNumericOnly inputmode="numeric" />
          </div>

          <!-- تعداد فاز-->
          <div class="position-relative col-12 col-md-4">
            <label class="mb-2 text-muted"> تعداد فاز </label>
            <input class="form-control p-2 text-center" formControlName="tiPhaseCount" appNumericOnly inputmode="numeric" />
          </div>

          <!-- تاریخ نصب -->
          <div class="col-12 col-md-4 position-relative">
            <label> تاریخ نصب </label>
            <ng-persian-datepicker
              [uiTheme]="'gray'"
              [timeEnable]="false"
              [dateGregorianFormat]="'YYYY/MM/DD'"
              [dateFormat]="'jYYYY/jMM/jDD'"
              [dateInitValue]="true">
              <input formControlName="strInstallDate" class="form-control text-end" />
            </ng-persian-datepicker>
          </div>

          <!-- وضعیت ژنراتور -->
          <div class="col-12 col-md-4 position-relative">
            <label class="mb-2 text-muted"> وضعیت ژنراتور </label>
            <select class="form-select p-2" formControlName="tiGeneratorStatus">
              <option class="text-center" value="">انتخاب کنید</option>
              <option class="text-center" *ngFor="let item of generatorStatus" [value]="item.tiGeneratorStatus">
                {{ item.strTitle }}
              </option>
            </select>
          </div>

          <!-- نوع سوخت -->
          <div class="col-12 col-md-4 position-relative">
            <label class="mb-2 text-muted"> نوع سوخت </label>
            <select class="form-select p-2" formControlName="tiFuelType">
              <option class="text-center" value="">انتخاب کنید</option>
              <option class="text-center" *ngFor="let item of fuelType" [value]="item.tiFuelType">
                {{ item.strTitle }}
              </option>
            </select>
          </div>

          <!-- مصرف سوخت ساعتی -->
          <div class="position-relative col-12 col-md-4">
            <label class="mb-2 text-muted"> مصرف سوخت ساعتی </label>
            <input class="form-control p-2 text-center" formControlName="fFuelConsumptionPerHour" appNumericOnly inputmode="numeric" />
          </div>

          <!-- تاریخ اعتبار -->
          <div class="col-12 col-md-4 position-relative">
            <label> تاریخ اعتبار </label>
            <ng-persian-datepicker
              [uiTheme]="'gray'"
              [timeEnable]="false"
              [dateGregorianFormat]="'YYYY/MM/DD'"
              [dateFormat]="'jYYYY/jMM/jDD'"
              [dateInitValue]="true">
              <input formControlName="strExpireDate" class="form-control text-end" />
            </ng-persian-datepicker>
          </div>

        </div>
      </div>
      <div class="modal-footer d-flex justify-content-start">
        <ng-container *ngIf="addOrEditForm">
          <button class="btn btn-success" (click)="submitForm()"> 
            {{ addOrEditForm.get("iLoadWatch")?.value ? 'ویرایش' : 'ثبت' }} اطلاعات
          </button>
        </ng-container>
        <button class="btn btn-outline-secondary" data-bs-dismiss="modal">
          &nbsp; بستن &nbsp;
        </button>
      </div>
    </div>
  </div>
</div>
